function question_matches_mapping(item = {}, source_question_id = 0, source_label = '', normalize_label) {
  const question_id_matches = source_question_id > 0 && Number(item?.id || 0) === source_question_id;
  const item_label = typeof normalize_label === 'function' ? normalize_label(item?.label || '') : '';
  const label_matches = source_label && (
    item_label === source_label
    || item_label.includes(source_label)
    || source_label.includes(item_label)
  );
  return question_id_matches || label_matches;
}

function find_matching_question(sub_section = {}, source_question_id = 0, source_label = '', normalize_label) {
  const questions = Array.isArray(sub_section?.questions) ? sub_section.questions : [];
  return questions.find((item) => (
    question_matches_mapping(item, source_question_id, source_label, normalize_label)
  ));
}

function collect_form_sub_sections(form_sections = []) {
  return form_sections.flatMap((form_section) => (
    (Array.isArray(form_section?.sections) ? form_section.sections : [])
      .flatMap((section) => (Array.isArray(section?.sub_sections) ? section.sub_sections : []))
  ));
}

function document_matches_mapping(document = {}, source_question_id = 0, source_label = '', normalize_label) {
  const document_question_id = Number(document?.question_id || document?.section_question_id || 0);
  const question_id_matches = source_question_id > 0 && document_question_id === source_question_id;
  const label_value = [
    document?.question,
    document?.document,
    document?.name,
    document?.document_name,
    document?.file_name,
    document?.section
  ].find((value) => String(value || '').trim() !== '');
  const normalized_document_label = typeof normalize_label === 'function'
    ? normalize_label(label_value || '')
    : '';
  const label_matches = source_label && (
    normalized_document_label === source_label
    || normalized_document_label.includes(source_label)
    || source_label.includes(normalized_document_label)
  );

  return question_id_matches || label_matches;
}

function find_matching_document(documents = [], source_question_id = 0, source_label = '', normalize_label) {
  return (Array.isArray(documents) ? documents : []).find((document) => (
    document_matches_mapping(document, source_question_id, source_label, normalize_label)
  )) || null;
}

function build_document_mapping_answer(document = {}) {
  const file_name = String(
    document?.file_name
    || document?.name
    || document?.document_name
    || document?.question
    || ''
  ).trim();
  const file_url = String(
    document?.presigned_url
    || document?.file_url
    || document?.url
    || document?.document_url
    || ''
  ).trim();

  return {
    answer: file_name || file_url,
    file_url,
    file_name,
    type: String(document?.content_type || document?.mime_type || document?.file_type || '').trim()
  };
}

export function find_submitted_answer_for_mapping(form_sections = [], mapping = {}, normalize_label, documents = []) {
  const source_question_id = Number(mapping?.onboarding_section_question || 0);
  const source_labels = [
    mapping?.onboarding_question_text,
    mapping?.manual_question_text,
    mapping?.verification_question_text
  ]
    .map((value) => (
      typeof normalize_label === 'function'
        ? normalize_label(value || '')
        : String(value || '').trim().toLowerCase()
    ))
    .filter(Boolean);

  for (const source_label of source_labels.length ? source_labels : ['']) {
    const matching_question = collect_form_sub_sections(form_sections)
      .map((sub_section) => find_matching_question(
        sub_section,
        source_question_id,
        source_label,
        normalize_label
      ))
      .find(Boolean);

    if (matching_question) {
      return {
        answer: matching_question?.answer || '',
        file_url: matching_question?.file_url || '',
        file_name: matching_question?.file_name || '',
        type: matching_question?.type || ''
      };
    }

    const matching_document = find_matching_document(documents, source_question_id, source_label, normalize_label);
    if (matching_document) {
      return build_document_mapping_answer(matching_document);
    }
  }

  return {
    answer: '',
    file_url: '',
    file_name: '',
    type: ''
  };
}
